var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui-icon', ("ui-icon__" + _vm.name), {active: _vm.active, disabled: _vm.disabled}, _vm.iconSize],on:{"click":function($event){_vm.$emit('click')}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6a77cfa","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/icon/index.vue
// module id = 493
// module chunks = 0 1 2 3 4